import L from "leaflet";
import { GPX } from "leaflet-gpx";

export const mapCreator = {
  createMap(lat = 0, lon = 0) {
    const map = L.map("container-map").setView([lat, lon], 5);
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3NzZWVlYmJiIiwiYSI6ImNra2ZodXp4eDA0Zjkyb29ncDJ3OTA4NXUifQ.yr5fwMNzTqQaOpSHnqT0XQ",
      {
        // maxZoom: 19,
        zoomOffset: -1,
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
          'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        id: "ssseeebbb/ckkfhwhy300o217qavznrhcdy",
        tileSize: 512,
      }
    ).addTo(map);
    return map;
  },
  createMarker(map, lat, lon) {
    const myIcon = L.icon({
      iconUrl: "/img/map/pin-icon-wpt.png",
      iconSize: [22, 34],
      iconAnchor: [11, 34],
      // popupAnchor: [-3, -76],
      // shadowUrl: 'my-icon-shadow.png',
      // shadowSize: [68, 95],
      // shadowAnchor: [22, 94]
    });
    return L.marker([lat, lon], { icon: myIcon }).addTo(map);
  },
  async importGpx(map, gpx, options = {}) {
    let color = "#215987"; // color blue by default

    if (options.color) color = options.color;

    const gpxUpload = new Promise((resolve, reject) => {
      var g = new L.GPX(gpx, {
        async: true,
        polyline_options: {
          color: color,
          opacity: 1,
          weight: 3,
          lineCap: "round",
        },
        marker_options: {
          startIconUrl: "", // Si on veut rajouter une icone de début et de fin du trail
          endIconUrl: "",
          shadowUrl: "",
          wptIconUrls: {
            "": "",
          },
        },
      });
      g.on("loaded", function(e) {
        map.fitBounds(e.target.getBounds());
        resolve("done");
      });
      g.addTo(map);
    });

    const res = await gpxUpload;
    return res;
  },
};

export const elevation_options = {
  // Default chart colors: theme lime-theme, magenta-theme, ...
  theme: "lightblue-theme",

  // Chart container outside/inside map container
  detached: false,

  // if (detached), the elevation chart container
  elevationDiv: "#elevation-div",

  // if (!detached) autohide chart profile on chart mouseleave
  autohide: false,

  // if (!detached) initial state of chart profile control
  collapsed: true,

  // if (!detached) control position on one of map corners
  position: "bottomright",

  // Autoupdate map center on chart mouseover.
  followMarker: false,

  // Chart distance/elevation units.
  imperial: false,

  // [Lat, Long] vs [Long, Lat] points. (leaflet default: [Lat, Long])
  reverseCoords: false,

  // Summary track info style: "line" || "multiline" || false,
  summary: false,

  //On ajoute un lien de téléchargement du gpx 'link' = default
  downloadLink: false,

  legend: false,
};
